import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MilestoneDisplay } from "@shared/interfaces/ProgramFiles";
import { useMilestone } from "@pages/Program/components/milestones/utils/useMilestone";
import DeleteEntityModal from "@pages/Program/components/DeleteEntity";
import Event from "@pages/Program/components/calendar/components/Event";
import MilestonesModal from "../../milestones/MilestonesModal";

interface EventListProps {
  events: MilestoneDisplay[];
  msViewStart: Date;
  weeksPerView: number;
  columnWidth: number;
  eventHeight: number;
  fetchMilestone: () => void;
  startDate?: string;
  endDate?: string;
}

const EventList: React.FC<EventListProps> = ({
  events,
  msViewStart,
  weeksPerView,
  columnWidth,
  eventHeight,
  fetchMilestone,
  startDate,
  endDate,
}) => {
  const { deleteMilestone } = useMilestone();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState<MilestoneDisplay>(
    {} as MilestoneDisplay
  );
  const [searchParams] = useSearchParams();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteMilestone = async () => {
    try {
      await deleteMilestone(selectedEntity.id);
      fetchMilestone();
    } catch {
      console.error("Failed to delete milestone");
    }
    setModalOpen(false);
    setSelectedEntity({} as MilestoneDisplay);
  };

  return (
    <>
      {events
        .sort((a, b) => {
          return (
            new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
          );
        })
        .map((event, index) => (
          <Event
            key={event.id}
            event={event}
            index={index}
            msViewStart={msViewStart}
            weeksPerView={weeksPerView}
            columnWidth={columnWidth}
            eventHeight={eventHeight}
            onClick={() => {
              setSelectedEntity(event);
              setIsModalOpen(true);
            }}
          />
        ))}

      {isModalOpen && selectedEntity && startDate && endDate && (
        <MilestonesModal
          title={""}
          milestones={[selectedEntity]}
          onClose={() => setIsModalOpen(false)}
          singleMilestone={true}
          startDate={startDate}
          endDate={endDate}
          fetchMilestone={fetchMilestone}
          allowEdit={true}
        />
      )}

      <DeleteEntityModal
        isOpen={modalOpen}
        selectedEntity={selectedEntity}
        onClose={() => setModalOpen(false)}
        onConfirm={handleDeleteMilestone}
      />
    </>
  );
};

export default EventList;
